import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.626 8.877 20 3.46l-4.255 4.983L9.209 7.31l.003 6.512-5.76 3.261 4.276 4.998-2.275 6.127 6.545 1.13 2.263 6.113 5.74-3.256 5.738 3.256 2.264-6.114 6.545-1.13-2.276-6.126 4.277-4.998-6.269-3.548-.985 1.74 4.156 2.353-3.463 4.047 1.846 4.971-5.307.916-1.847 4.989L20 29.894l-4.68 2.656-1.847-4.989-5.307-.916 1.846-4.971-3.463-4.047 4.664-2.64-.003-5.3 5.315.922L20 6.539l3.105 3.637 1.521-1.3Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m30.663 4.952-11.502 17.58-4.354-5.938-1.613 1.182 6.06 8.267L32.337 6.047l-1.674-1.095Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramB2BVerifiedSymbol40 = createIcon(IconComponent);